/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { InputForm } from '../../inputs/forms/InputForm';
import { useFetch } from '../../../hooks/useFetch';
import { ImageInputForm } from '../../inputs/forms/ImageInputForm';
import { TextAreaInputForm } from '../../inputs/forms/TextAreaInputForm';
import { MaskedInputForm } from '../../inputs/forms/MaskedInputForm';
import { CepField } from '../../inputs/forms/CepField';
import { FormActions, FormRow, FormSection, FormShell } from '../../ui';

interface GeneralSettingsFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: string;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function GeneralSettingsForm({ defaultValues = {} }: GeneralSettingsFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/globals';
  const { requestApi: reqApiSettings } = useFetch(baseUrl);
  const { requestApi: reqApiCodepost, error: errorCodepost } = useFetch('/v1/client/address');
  const [images, setImages] = useState<any>('');
  const [loadingCodepost, setLoadingCodepost] = useState<any>(false);
  const [uploading, setUploading] = useState<any>(false);
  const [address, setAddress] = useState<any>({});
  const [isFirstRender, setIsFirstRender] = useState(true);
  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues.name ?? '',
      placeholder: '',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'social_name',
      value: defaultValues.social_name ?? '',
      placeholder: '',
      label: 'Razão Social',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'cnpj',
      value: defaultValues.cnpj ?? '',
      placeholder: '',
      label: 'CNPJ',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'description',
      value: defaultValues.description ?? '',
      placeholder: '',
      label: 'Descrição',
      yup: Yup.string(),
    },
    {
      name: 'code_post',
      value: defaultValues?.code_post ?? '',
      placeholder: '',
      label: 'CEP',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_id',
      value: defaultValues?.city?.id ?? '',
      placeholder: '',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_name',
      value: defaultValues?.city?.name ?? '',
      placeholder: '',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'state_name',
      value: defaultValues?.city?.state?.name ?? '',
      placeholder: '',
      label: 'Estado',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'street',
      value: defaultValues?.street ?? '',
      placeholder: '',
      label: 'Rua',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'number',
      value: defaultValues?.number ?? '',
      placeholder: '',
      label: 'Número',
      yup: Yup.string(),
    },
    {
      name: 'district',
      value: defaultValues?.district ?? '',
      placeholder: '',
      label: 'Bairro',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'complement',
      value: defaultValues?.complement ?? '',
      placeholder: '',
      label: 'Complemento',
      yup: Yup.string(),
    },
    {
      name: 'image',
      value: defaultValues.logo?.original ?? null,
      placeholder: '',
      label: 'Imagem',
      yup: Yup.mixed().nullable(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const name = formInputs.find((field) => field.name === 'name');
  const socialName = formInputs.find((field) => field.name === 'social_name');
  const cnpj = formInputs.find((field) => field.name === 'cnpj');
  const description = formInputs.find((field) => field.name === 'description');
  const codePost = formInputs.find((field) => field.name === 'code_post');
  const city = formInputs.find((field) => field.name === 'city_name');
  const state = formInputs.find((field) => field.name === 'state_name');
  const street = formInputs.find((field) => field.name === 'street');
  const number = formInputs.find((field) => field.name === 'number');
  const district = formInputs.find((field) => field.name === 'district');
  const complement = formInputs.find((field) => field.name === 'complement');
  const image = formInputs.find((field) => field.name === 'image');

  const onSubmit = async (values: any) => {
    const params = {
      ...values,
      address: {
        code_post: values.code_post,
        city_id: Number(values.city_id),
        street: values.street,
        number: values.number,
        district: values.district,
        complement: values.complement,
      },
      code_post: _,
      city_id: _,
      city_name: _,
      state_name: _,
      street: _,
      number: _,
      district: _,
      complement: _,
      image: _,
    };
    const { status: resStatus, data } = await reqApiSettings('put', params);
    if ((resStatus === 200 || resStatus === 201) && images) {
      setUploading(true);
      await reqApiSettings(
        'put',
        { image: images.toString() },
        `${baseUrl}/${data?.data?.id}/images`
      );
      setUploading(false);
    }
  };

  const getCep = async (cep) => {
    const { data, status: resStatus } = await reqApiCodepost('get', { params: { code_post: cep } });
    if (resStatus === 200) {
      setAddress(data?.data);
    } else {
      setAddress({});
    }
    setLoadingCodepost(false);
  };

  useEffect(() => {
    if (defaultValues?.name) {
      reset(defaultValuesSchema);
    }
  }, [defaultValues]);

  useEffect(() => {
    setValue('city_id', address?.city?.id);
    setValue('city_name', address?.city?.name);
    setValue('state_name', address?.city?.state?.name);
    setValue('street', address?.street);
    setValue('district', address?.district);
  }, [address]);

  useEffect(() => {
    if (watch('code_post').replace(/\D/g, '').length < 8) {
      setAddress(null);
      return;
    }
    if (!isFirstRender) {
      setLoadingCodepost(true);
      const timeout = setTimeout(() => {
        getCep(watch('code_post').replace(/\D/g, ''));
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [watch('code_post')]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  return (
    <FormShell
      title="Configurações Gerais"
      description="Dados institucionais exibidos em documentos e comunicações."
    >
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormSection title="Dados básicos">
          <FormRow>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={socialName?.name}
              label={socialName?.label}
              placeholder={socialName?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <MaskedInputForm
              name={cnpj?.name}
              label={cnpj?.label}
              placeholder={cnpj?.placeholder}
              control={control}
              errors={errors}
              mask="99.999.999/9999-99"
              isRequired
            />
          </FormRow>
          <TextAreaInputForm
            name={description?.name}
            label={description?.label}
            placeholder={description?.placeholder}
            errors={errors}
            register={register}
          />
          <ImageInputForm
            compact={false}
            defaultVal={defaultValues?.logo}
            setImages={setImages}
            setIsUpping={setUploading}
            name={image?.name}
            label={image?.label}
            register={register}
            watch={watch}
            setValue={setValue}
            errors={errors}
          />
        </FormSection>

        <FormSection title="Endereço">
          <FormRow>
            <CepField
              name={codePost?.name}
              label={codePost?.label}
              placeholder={codePost?.placeholder}
              control={control}
              errors={errors}
              isLoading={loadingCodepost}
              notFoundMessage={errorCodepost?.status === 404 ? errorCodepost?.msg : undefined}
            />
            <InputForm
              name={city?.name}
              label={city?.label}
              placeholder={city?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={state?.name}
              label={state?.label}
              placeholder={state?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </FormRow>
          <FormRow gridTemplateColumns={{ base: '1fr', md: '2fr 1fr 2fr 2fr' }}>
            <InputForm
              name={street?.name}
              label={street?.label}
              placeholder={street?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={number?.name}
              label={number?.label}
              placeholder={number?.placeholder}
              type="number"
              register={register}
              errors={errors}
            />
            <InputForm
              name={district?.name}
              label={district?.label}
              placeholder={district?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={complement?.name}
              label={complement?.label}
              placeholder={complement?.placeholder}
              register={register}
              errors={errors}
            />
          </FormRow>
        </FormSection>

        <FormActions isLoading={isSubmitting || uploading} />
      </Box>
    </FormShell>
  );
}
